export const fireSwal = async (...args) => {
  const { default: Swal } = await import("sweetalert2");
  return Swal.fire(...args);
};
